/**
 * Free-watch UI is driven by `/api/user/get` field `remaining_user_time` (seconds).
 * Backend should set it to 0 when the free window ends.
 */

function parseRemainingUserTimeRaw(raw) {
  if (raw === null || raw === undefined || raw === "") return 0;

  let n = 0;
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    const isStrictNumeric = /^-?\d+(\.\d+)?$/.test(trimmed);
    if (!isStrictNumeric) return 0;
    n = Number(trimmed);
  } else {
    n = Number(raw);
  }

  if (!Number.isFinite(n) || n <= 0) return 0;
  return n;
}

/**
 * @param {object|null|undefined} profileData - `data` from GET `/api/user/get`
 * @returns {number} seconds left from `remaining_user_time` only
 */
export function getRemainingUserTimeSeconds(profileData) {
  if (!profileData || typeof profileData !== "object") return 0;
  return parseRemainingUserTimeRaw(profileData.remaining_user_time);
}

/** @deprecated use {@link getRemainingUserTimeSeconds} */
export function resolveFreeWatchRemainingSeconds(profileData) {
  return getRemainingUserTimeSeconds(profileData);
}
